// =============================================================================
// phaseRailIndex — the DNA interview's turn-state-machine phase→rail-index
// decision, extracted as its own pure function (LANE DNA-BUILD, Phase 1).
// Mirrors radarPath.ts's placement precedent (pure geometry/logic siblings
// live beside their component in components/, not folded inline into JSX) so
// this is directly unit-testable without a DOM/React-Testing-Library harness
// (absent from this repo — house pattern, no RTL render tests anywhere).
//
// The rule this pins: 'complete' collapses onto the LAST phase (every step
// lit — the interview finished, nothing left to walk toward), any other
// known phase key lights up itself + every phase before it, and an unknown
// phase string returns -1 (no step lit) rather than crashing or guessing.
// =============================================================================

export const DNA_PHASES = [
  { key: 'origins', label: 'Origins' },
  { key: 'timeline', label: 'Timeline' },
  { key: 'synthesis', label: 'Synthesis' },
] as const;

export type DnaPhaseKey = (typeof DNA_PHASES)[number]['key'];

/** The index (into DNA_PHASES) of the current phase, for the rail's "lit up
 *  through here" highlighting. 'complete' maps to the last index (every step
 *  lit); an unrecognised phase string returns -1 (nothing lit, never a
 *  guessed/invented index). */
export function phaseRailIndex(phase: string): number {
  if (phase === 'complete') return DNA_PHASES.length - 1;
  return DNA_PHASES.findIndex((p) => p.key === phase);
}
